import { memo } from 'react';
import memoize from 'transmute/memoize';
import { DEFAULT_DEBUG } from '../../constants/debug';
import { VENN } from '../../constants/visualizationTypes';
import { VennVisualizationRecord, VennChartOptions } from './VennRecords';
import { getVennOptions } from './VennMapper';
// @ts-expect-error untyped dependency
import Highchart from '../../highcharts/Highchart';
import { buildVennChartOptions } from './options/chartOptions';
import { jsx as _jsx } from "react/jsx-runtime";
export const getHighchartsOptions = memoize((vennVisualization, debug, reportingThemes) => {
  const vennOptions = getVennOptions(vennVisualization, debug);
  return buildVennChartOptions(VennChartOptions(vennOptions), reportingThemes);
});
export const type = VENN;
export const record = VennVisualizationRecord;
const VennViz = ({
  visualization,
  debug = DEFAULT_DEBUG,
  onReportVisualize,
  reportingThemes
}) => {
  const chartOptions = getHighchartsOptions(visualization, debug, reportingThemes);
  debug.set('Highcharts', chartOptions);
  return /*#__PURE__*/_jsx(Highchart, {
    chartOptions: chartOptions,
    setExtremesForZeroState: false,
    onReportVisualize: onReportVisualize
  });
};
export const Render = /*#__PURE__*/memo(VennViz);